export const apiUrl = process.env.REACT_APP_API_URL;
export const apiIPUrl = process.env.REACT_APP_IPAPI_URL;

// Share
export const ENDPOINT_CREATE_SHARE = `${apiUrl}/shares`;
export const ENDPOINT_GET_SHARE_BY_UID = `${apiUrl}/shares`;
export const ENDPOINT_GENERATE_DOWNLOAD = `${apiUrl}/generate-share-download-link`;

// Upload
export const ENDPOINT_UPLOAD_CHUNCK = `${apiUrl}/upload-chunk`;
export const ENDPOINT_CHECKED_SHARE_IN = `${apiUrl}/upload/checked-share-in`;

// Authentication
export const ENDPOINT_OTP_LOGIN = `${apiUrl}/auth/otp-login`;
export const ENDPOINT_OTP_REQUEST = `${apiUrl}/auth/otp-request`;
export const ENDPOINT_OTP_REFRESH_TOKEN = `${apiUrl}/auth/refresh-token`;

// Request IP infos
export const ENDPOINT_REQUEST_IPAPI = `${apiIPUrl}`